type RGB = `rgb(${number}, ${number}, ${number})`;
type RGBA = `rgba(${number}, ${number}, ${number}, ${number})`;
type HEX = `#${string}`;

export type CSSColor = RGB | RGBA | HEX;

export type CSSPosition = "top" | "bottom" | "left" | "right";

export enum MediaQueryBreakpoint {
    MD = 768,
    LG = 1280,
}

export type IconTheme = {
    background?: string;
    border?: string;
    fill?: string;
};

export type ColorsTheme = {
    main: string;
    secondary?: string;
    hover?: string;
    active?: string;
    disabled?: string;
    text?: string;
};

export type ElementTheme = {
    colors?: ColorsTheme;
    icon?: IconTheme | ColorsTheme;
};
